import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LeadRequestDialogComponent } from '../../leads/lead-request-dialog/lead-request-dialog.component';

@Component({
  selector: 'app-practice-areas',
  templateUrl: './practice-areas.component.html',
  styleUrls: ['./practice-areas.component.scss']
})
export class PracticeAreasComponent implements OnInit {
  constructor(private dialog: MatDialog) {}

  ngOnInit() {
  }

  openLeadForm(legalAreaSlug: string): void {
    this.dialog.open(LeadRequestDialogComponent, {
      width: '720px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      panelClass: 'lead-request-dialog-panel',
      data: { legalAreaSlug }
    });
  }
}
